import React from "react";
import BaseEdge, { roundTo } from "./BaseEdge";

export default function CurvedEdge({
  edge,
  nodeById,
  edgeIndex,
  selectedIndex,
  onSelectEdge,
  onStartEdgeDrag,
  color,
  isHovered,
  onHoverEnter,
  onHoverLeave,
}) {
  const from = nodeById[edge.from];
  const to = nodeById[edge.to];
  if (!from || !to) return null;

  const src = {
    x: roundTo(from.x + from.width / 2),
    y: roundTo(from.y + from.height / 2),
  };

  const dst = {
    x: roundTo(to.x + to.width / 2),
    y: roundTo(to.y + to.height / 2),
  };

  // midpoint
  const mx = (src.x + dst.x) / 2;
  const my = (src.y + dst.y) / 2;

  // direction vector
  const dx = dst.x - src.x;
  const dy = dst.y - src.y;
  const len = Math.hypot(dx, dy) || 1;

  // normal vector (perpendicular)
  const nx = -dy / len;
  const ny = dx / len;

  // curvature magnitude
  const curvature = 40;

  // control point (curved edge)
  const cx = mx + nx * curvature;
  const cy = my + ny * curvature;

  const d = `M ${src.x} ${src.y} Q ${cx} ${cy} ${dst.x} ${dst.y}`;

  const labelPos = {
    x: mx,
    y: my - 12,
  };

  return (
    <BaseEdge
      d={d}
      stroke={color}
      // NEW HOVER SUPPORT
      isHovered={isHovered}
      onHoverEnter={onHoverEnter}
      onHoverLeave={onHoverLeave}
      onSelect={() => onSelectEdge(edgeIndex)}
      onStartDrag={(e) =>
        onStartEdgeDrag(edgeIndex, {
          clientX: e.clientX,
          clientY: e.clientY,
        })
      }
      label={edge.label}
      labelPos={labelPos}
    />
  );
}
